<template>
  <div id="sizeTemplate" v-if="sizeData.openSize">
    <div id="actionButton">
      <q-btn color="primary" unelevated label="search size"
      style="margin-left:5px;height:35px;margin-bottom:3px;" @click="selectionCheck()">
        <q-menu>
          <q-list style="min-width: 144.88px">
            <q-item clickable v-close-popup v-for="(item,index) in sizeTemplates" :key="index" @click="onSetTemplate(sizeData.tabName,item,index)">
              <q-item-section>{{item.name}}</q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-btn>
    </div>
    <el-row
      :gutter="20"
      class="text-md-center"
      style="margin-top:10px;"
    >
      <el-col :span="2">
        <b>ลำดับ</b>
      </el-col>
      <el-col :span="5">
        <b>Min size</b>
      </el-col>
      <el-col :span="5">
        <b>Max size</b>
      </el-col>
      <el-col :span="5">
        <b>Rate-BKK</b>
      </el-col>
      <el-col :span="5">
        <b>Rate-UPC</b>
      </el-col>
    </el-row>
    <RecycleScroller
      class="scroller"
      :items="sizeData.data.shopDetail.dimensionRate[sizeData.tabName]"
      :item-size="55"
      :prerender="10"
      :buffer="20"
      style="height: 100%;"
      key-field="max"
      v-slot="{ item, index }"
    >
      <div class="user">
        <el-row :gutter="20">
          <el-col :span="2" style="padding-top: 20px; text-align: center;">
            {{index+1}}
          </el-col>
          <el-col :span="20">
            <el-row :gutter="20">
              <el-col
                :span="6"
                style="margin-top:10px;"
              >
                <vue-numeric
                  :precision="2"
                  separator=","
                  v-model="item.min"
                  ref="rate"
                  class="el-input__inner"
                ></vue-numeric>
              </el-col>
              <el-col
                :span="6"
                style="margin-top:10px;"
              >
                <vue-numeric
                  :precision="2"
                  separator=","
                  v-model="item.max"
                  class="el-input__inner"
                ></vue-numeric>
              </el-col>
              <el-col
                :span="6"
                style="margin-top:10px;"
              >
                <vue-numeric
                  :precision="2"
                  separator=","
                  v-model="item.rateBkk"
                  class="el-input__inner"
                ></vue-numeric>
              </el-col>
              <el-col
                :span="6"
                style="margin-top:10px;"
              >
                <vue-numeric
                  :precision="2"
                  separator=","
                  v-model="item.rateUpc"
                  class="el-input__inner"
                ></vue-numeric>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </RecycleScroller>
  </div>
</template>

<script>
import VueNumeric from 'vue-numeric'
let sizeTemplates = require('@/utils/sizeTemplates.json')

export default {
    name: 'SizeTemplate',
    inject: ['getToggleTemplateData'],
    data () {
        return {
            sizeTemplates: []
        }
    },
    components: {
        VueNumeric
    },
    computed: {
        sizeData () {
            return this.getToggleTemplateData()
        }
    },
    methods: {
        selectionCheck () {
            const selectionData = JSON.parse(JSON.stringify(sizeTemplates))
            this.sizeTemplates = selectionData.filter(e => e.typeName === this.sizeData.tabName)
        },
        onSetTemplate (itemTab, item, index) {
            this.$set(this.sizeData.data.shopDetail.dimensionRate, itemTab, item.value)
        }
    }
}
</script>

<style lang="scss" scoped>
  #sizeTemplate {
    #actionButton {
      margin-top: 20px;
    }
  }
</style>
